import { Outlet, ScrollRestoration } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';

const Root = () => {
  return (
    <>
      <CssBaseline />
      <Outlet />
      <ScrollRestoration />
    </>
  );
};

export default Root;
